import { useEffect, type ReactNode } from 'react';
import { PrivyProvider, usePrivy } from '@privy-io/react-auth';
import { setTokenSource } from './token';
import { privyConfig, PRIVY_APP_ID } from './privy';
import { XLinkWatcher } from './xlink';

/** Privy owns the session; the API client reads the access token through setTokenSource (auth/token.ts). */
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <PrivyProvider appId={PRIVY_APP_ID} config={privyConfig}>
      <TokenBridge />
      <XLinkWatcher />
      {children}
    </PrivyProvider>
  );
}

function TokenBridge() {
  const { getAccessToken } = usePrivy();
  useEffect(() => {
    setTokenSource(getAccessToken);
    return () => setTokenSource(async () => null);
  }, [getAccessToken]);
  return null;
}
